module.exports = __webpack_public_path__ + "img/menu-icon.e6389b08.svg";